module.exports = __webpack_public_path__ + "static/media/licencia_frente.c270023e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/user/licencia_frente.jpg
// module id = 649
// module chunks = 0